/**
 * FIX-TOOLTIP (2026-11-01): the D-284 clipped-text titles in `DataTable` may only
 * land on nodes INSIDE the table frame. React bubbles events from portals (row
 * menus, popovers, dialogs) up to the table, but in the DOM those nodes sit under
 * <body>: walking up from them reached <html> (clipped, since the page scrolls)
 * and gave it the whole document's text (head scripts, title, injected CSS) as a
 * title, shown on hover everywhere in the site.
 */

/** Never titled: the page roots. */
const PAGE_ROOTS = new Set(['HTML', 'HEAD', 'BODY']);

/** How far up from the pointer the walk may go (a cell's content is shallow). */
export const MAX_TIP_DEPTH = 16;

/** True when `node` is a real descendant of the table frame (not the frame itself, not a page root). */
export function isInsideTable(
  node: { nodeName: string } | null | undefined,
  frame: { contains(other: any): boolean } | null | undefined,
): boolean {
  if (!node || !frame || (node as unknown) === frame) return false;
  if (PAGE_ROOTS.has(node.nodeName.toUpperCase())) return false;
  return frame.contains(node);
}
